export const LOAD_COMMENTS_SUCCESS = `LOAD_COMMENTS_SUCCESS`;
export const LOAD_MORE_COMMENTS_SUCCESS = `LOAD_MORE_COMMENTS_SUCCESS`;
export const ADD_COMMENT_SUCCESS = `ADD_COMMENT_SUCCESS`;
export const DELETE_COMMENT_SUCCESS = `DELETE_COMMENT_SUCCESS`;
export const ADD_COMMENT_LIKE_SUCCESS = `ADD_COMMENT_LIKE_SUCCESS`;
export const REMOVE_COMMENT_LIKE_SUCCESS = `REMOVE_COMMENT_LIKE_SUCCESS`;
export const REPLY_TO_COMMENT_SUCCESS = `REPLY_TO_COMMENT_SUCCESS`;
export const DELETE_REPLY_SUCCESS = `DELETE_REPLY_SUCCESS`;
export const ADD_REPLY_LIKE_SUCCESS = `ADD_REPLY_LIKE_SUCCESS`;
export const REMOVE_REPLY_LIKE_SUCCESS = `REMOVE_REPLY_LIKE_SUCCESS`;
export const REPORT_COMMENT_SUCCESS = `REPORT_COMMENT_SUCCESS`;
export const REPORT_REPLY_SUCCESS = `REPORT_REPLY_SUCCESS`;

export const LOAD_CONTENT_SUCCESS = `LOAD_CONTENT_SUCCESS`;
export const UPDATE_CONTENT_SUCCESS = `UPDATE_CONTENT_SUCCESS`;
export const CREATE_CONTENT_SUCCESS = `CREATE_CONTENT_SUCCESS`;

export const LOAD_CONTENT_LIST_SUCCESS = `LOAD_CONTENT_LIST_SUCCESS`;
export const LOAD_MORE_CONTENT_LIST_SUCCESS = `LOAD_MORE_CONTENT_LIST_SUCCESS`;
export const DELETE_FROM_CONTENT_LIST_SUCCESS = `DELETE_FROM_CONTENT_LIST_SUCCESS`;

export const LOAD_SESSION_SUCCESS = `LOAD_SESSION_SUCCESS`;

export const LOAD_DIAGRAM_SUCCESS = `LOAD_DIAGRAM_SUCCESS`;
export const UPDATE_DIAGRAM_SUCCESS = `UPDATE_DIAGRAM_SUCCESS`;
export const CREATE_DIAGRAM_SUCCESS = `CREATE_DIAGRAM_SUCCESS`;

export const LOAD_METADATA_SUCCESS = `LOAD_METADATA_SUCCESS`;

export const LOAD_FAVOURITE_SUCCESS = `LOAD_FAVOURITE_SUCCESS`;
export const ADD_FAVOURITE_SUCCESS = `ADD_FAVOURITE_SUCCESS`;
export const REMOVE_FAVOURITE_SUCCESS = `REMOVE_FAVOURITE_SUCCESS`;

export const GET_LOGGED_IN_USER_SUCCESS = `GET_LOGGED_IN_USER_SUCCESS`;
export const GET_LOGGED_IN_USER_ERROR = `GET_LOGGED_IN_USER_ERROR`;
export const GET_USER_LOCATION_SUCCESS = `GET_USER_LOCATION_SUCCESS`;
export const IS_USER_COACH_SUCCESS = `IS_USER_COACH_SUCCESS`;
export const IS_USER_PLAYER_SUCCESS = `IS_USER_PLAYER_SUCCESS`;
export const GET_USER_SIGNUP_DETAILS_SUCCESS = `GET_SIGNUP_DETAILS_SUCCESS`;
export const UPDATE_EMAIL_SUCCESS = `UPDATE_EMAIL_SUCCESS`;
export const UPDATE_PHONE_NUMBER_SUCCESS = `UPDATE_PHONE_NUMBER_SUCCESS`;
export const UPDATE_EMAIL_PREFERENCES_SUCCESS = `UPDATE_EMAIL_PREFERENCES_SUCCESS`;
export const GET_AGE_CATEGORIES_SUCCESS = `GET_AGE_CATEGORIES_SUCCESS`;
export const UPDATE_COACH_AGE_PREFERENCES_SUCCESS = `UPDATE_COACH_AGE_PREFERENCES_SUCCESS`;
export const GET_ACCOUNT_DETAILS_SUCCESS = `GET_ACCOUNT_DETAILS_SUCCESS`;

export const GET_STRIPE_CUSTOMER_DETAILS_SUCCESS = `GET_STRIPE_CUSTOMER_DETAILS_SUCCESS`;
export const GET_STRIPE_CUSTOMER_DETAILS_ERROR = `GET_STRIPE_CUSTOMER_DETAILS_ERROR`;
export const CHECK_DISCOUNT_CODE_IS_VALID_SUCCESS = `CHECK_DISCOUNT_CODE_IS_VALID_SUCCESS`;
export const GET_STRIPE_CUSTOMER_PAYMENT_HISTORY_SUCCESS = `GET_STRIPE_CUSTOMER_PAYMENT_HISTORY_SUCCESS`;
export const GET_STRIPE_CUSTOMER_FUTURE_PAYMENT_SUCCESS = `GET_STRIPE_CUSTOMER_FUTURE_PAYMENT_SUCCESS`;

export const ADD_REPORT_SUCCESS = `ADD_REPORT_SUCCESS`;

export const DO_I_FOLLOW_SUCCESS = `DO_I_FOLLOW_SUCCESS`;
export const FOLLOW_TOGGLE_SUCCESS = `FOLLOW_SUCCESS`;

export const CAN_I_ACCESS_SUCCESS = `CAN_I_ACCESS_SUCCESS`;

export const ADD_SHARE_COUNT_SUCCESS = `ADD_SHARE_COUNT_SUCCESS`;

export const LOAD_MY_FOLDERS_SUCCESS = `LOAD_MY_FOLDERS_SUCCESS`;
export const LOAD_MY_FOLDERS_V2_SUCCESS = `LOAD_MY_FOLDERS_V2_SUCCESS`;
export const LOAD_FOLDER_V3_SUCCESS = `LOAD_FOLDER_V3_SUCCESS`;
export const GET_MY_FOLDERS_SUCCESS = `GET_MY_FOLDERS_SUCCESS`;
export const CREATE_FOLDER_SUCCESS = `CREATE_FOLDER_SUCCESS`;
export const CREATE_FOLDER_V2_SUCCESS = `CREATE_FOLDER_V2_SUCCESS`;
export const ADD_TO_FOLDER_SUCCESS = `ADD_TO_FOLDER_SUCCESS`;
export const EDIT_FOLDER_SUCCESS = `EDIT_FOLDER_SUCCESS`;
export const MOVE_FOLDER_OPTIMISTIC = `MOVE_FOLDER_OPTIMISTIC`;
export const MOVE_FOLDER_REVERT = `MOVE_FOLDER_REVERT`;
export const REPLACE_FOLDER_OPTIMISTIC = `REPLACE_FOLDER_OPTIMISTIC`;
export const REPLACE_FOLDER_COMPLETION = `REPLACE_FOLDER_COMPLETION`;
export const REPLACE_FOLDER_REVERT = `REPLACE_FOLDER_REVERT`;
export const DELETE_FOLDER_SUCCESS = `DELETE_FOLDER_SUCCESS`;
export const SHARE_FOLDER_SUCCESS = `SHARE_FOLDER_SUCCESS`;
export const REMOVE_FOLDER_SHARE_SUCCESS = `REMOVE_FOLDER_SHARE_SUCCESS`;
export const CHANGE_ITEM_FOLDER_OPTIMISTIC = `CHANGE_ITEM_FOLDER_OPTIMISTIC`;
export const CHANGE_ITEM_FOLDER_REVERT = `CHANGE_ITEM_FOLDER_REVERT`;
export const DELETE_ITEM_FROM_FOLDER_SUCCESS = `DELETE_ITEM_FROM_FOLDER_SUCCESS`;
export const LOAD_FOLDER_CONTENT_SUCCESS = `LOAD_FOLDER_CONTENT_SUCCESS`;
export const LOAD_AVAILABLE_ACCESSORS_SUCCESS = `LOAD_AVAILABLE_ACCESSORS_SUCCESS`;
export const LOAD_CURRENT_FOLDER_ACCESSORS_SUCCESS = `LOAD_CURRENT_FOLDER_ACCESSORS_SUCCESS`;

export const LOAD_IMAGES_SUCCESS = `LOAD_IMAGES_SUCCESS`;

export const LOAD_TRAINING_GROUND_CONTENT_FEED_SUCCESS = `LOAD_TRAINING_GROUND_CONTENT_FEED_SUCCESS`;
export const GET_TRAINING_GROUND_POPULAR_SEARCHES = `GET_TRAINING_GROUND_POPULAR_SEARCHES`;

export const GET_LICENCE_INFO_SUCCESS = `GET_LICENCE_INFO_SUCCESS`;
export const GET_ALLOCATED_LICENCES_SUCCESS = `GET_ALLOCATED_LICENCES_SUCCESS`;
export const ALLOCATE_LICENCE_SUCCESS = `ALLOCATE_LICENCE_SUCCESS`;
export const REMOVE_LICENCE_SUCCESS = `REMOVE_LICENCE_SUCCESS`;
export const EDIT_LICENCE_SUCCESS = `EDIT_LICENCE_SUCCESS`;

export const GET_SIGNUP_OPTIONS_SUCCESS = `GET_SIGNUP_OPTIONS_SUCCESS`;

export const ADD_NOTIFICATION_SUCCESS = `ADD_NOTIFICATION_SUCCESS`;

export const SEARCH_QUERY_SUCCESS = `SEARCH_QUERY_SUCCESS`;
export const LOAD_TRENDING_SEARCHES_SUCCESS = `LOAD_TRENDING_SEARCHES_SUCCESS`;
export const GET_SECONDARY_FILTERS_SUCCESS = `GET_SECONDARY_FILTERS_SUCCESS`;

export const GET_ORGANISATION_SUCCESS = `GET_ORGANISATION_SUCCESS`;

export const UPDATE_AWAITING_DOWNGRADE_SUCCESS = `UPDATE_AWAITING_DOWNGRADE_SUCCESS`;
export const GET_PAYMENT_BILLING_SUCCESS = `GET_PAYMENT_BILLING_SUCCESS`;


// WEBPACK FOOTER //
// ./library/app/actions/actionTypes.js